/*
 * @Author: zhangdingsong
 * @LastEditTime: 2023-11-07 10:07:57
 */
import { useEffect } from "react";
import { Breadcrumb, Carousel } from "antd";
import { useNavigate } from "react-router-dom";
import "../_style.scss";
import {
  BreadcrumbItem,
  BreadcrumbParentsItem,
} from "@root/common/interface/result";
import { useSelector } from "react-redux";
import { RootState } from "@root/store/index";
export default function BreadcrumbComponent(props: {
  pathname: string;
  curBreadcrumb: BreadcrumbItem | undefined;
  setDefaultKeys: (val: string) => void;
}) {
  const { pathname, curBreadcrumb, setDefaultKeys } = props;
  const { xy_navigation } = useSelector(
    (item: RootState) => item.advertisementData
  );
  const navigate = useNavigate();
  const onClick = (path: string | null) => {
    if (!path) {
      return;
    }
    navigate(path);
    setDefaultKeys(path);
  };
  // 后期可能为了统一风格，可能会都显示面包屑
  const showBreadcrumbRoutes = ["/new"];
  return curBreadcrumb &&
    showBreadcrumbRoutes.find((path) => pathname.includes(path)) ? (
    <div className="breadcrumbs-cover">
      <Carousel
        autoplay
        autoplaySpeed={2000}
        dots={{ className: "banner-custom-dots" }}
      >
        {xy_navigation.length > 0 &&
          xy_navigation.map((bannerItem: any) => {
            return (
              <div
                className="banner-item"
                onClick={async () => {
                  window.open(bannerItem.url);
                }}
              >
                <img
                  src={bannerItem.imageUrl}
                  alt=""
                  height={"150px"}
                  width={"100%"}
                />
              </div>
            );
          })}
      </Carousel>
      <Breadcrumb>
        {curBreadcrumb.parents?.map(
          (parentItem: BreadcrumbParentsItem, index: number) => {
            return (
              <Breadcrumb.Item
                onClick={() => {
                  onClick(parentItem.path);
                }}
                key={index}
              >
                {parentItem.title}
              </Breadcrumb.Item>
            );
          }
        )}
      </Breadcrumb>
    </div>
  ) : null;
}
